export enum HMSTrackType {
  AUDIO,
  VIDEO,
}
